/**
 * Utilitaire pour le suivi de performance de l'application (temps d'affichage, calculs, etc.)
 * Les entrées sont stockées dans le même log que les requêtes API (Parametres > Logs > Performance API)
 */
import { useEffect } from 'react';
import { logAppPerformance } from '../services/api';

/**
 * Hook qui mesure le temps d'affichage d'une page (mount → premier paint approximatif)
 * @param {string} pageName - Nom de la page (ex: 'Portefeuille', 'Compte', 'Analyse')
 */
export const usePageRenderTime = (pageName) => {
  useEffect(() => {
    if (typeof window === 'undefined' || !pageName) return;
    const start = performance.now();
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const duration = performance.now() - start;
        logAppPerformance('page', pageName, duration, 'affichage');
      });
    });
  }, [pageName]);
};

/**
 * Enregistre la durée d'un chargement de données (ex: loadPerformanceData, loadTRIData)
 * @param {string} name - Nom du chargement (ex: 'Compte - Performance', 'Compte - TRI')
 * @param {number} durationMs - Durée en millisecondes
 * @param {string} [detail] - Détail optionnel
 */
export const logDataLoad = (name, durationMs, detail) => {
  logAppPerformance('load', name, durationMs, detail);
};

/**
 * Enregistre la durée d'un calcul (ex: XIRR, enrichissement)
 * @param {string} name - Nom du calcul
 * @param {number} durationMs - Durée en millisecondes
 * @param {string} [detail] - Détail optionnel
 */
export const logCalculation = (name, durationMs, detail) => {
  logAppPerformance('calc', name, durationMs, detail);
};
